import { render, staticRenderFns } from "./UserMonitor.vue?vue&type=template&id=24d459dd"
import script from "./UserMonitor.vue?vue&type=script&lang=js"
export * from "./UserMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports